module.exports = __webpack_public_path__ + "img/ku_logo.81f84a46.png";